<template>
    <div class="com-calendar-info-bar dsp-flex">
        <div class="com-calendar-info-date" @click="clickCalendar">
            <div class="com-calendar-info-day-box">
                <p class="text-month">{{todayInfo.solar.m}}月</p>
                <p class="text-day">{{parseInt(todayInfo.solar.d)}}</p>
                <p class="text-week">{{ todayInfo.solar.week }}</p>
            </div>
        </div>
        <div class="com-calendar-info-detail" @click="clickCalendar">
            <div class="com-calendar-words dsp-flex">
                <div class="com-calendar-word" v-for="baziStr in todayInfo.bazi" v-bind:key="baziStr+Math.random(0, 10)">{{ baziStr }}</div>
            </div>
            <div class="com-calendar-sub-text">农历:{{ todayInfo.lunar.year }} <span>{{ todayInfo.lunar.date }}</span> {{todayInfo.lunar.sz.text}}时 </div>
        </div>
        <div class="com-calendar-marraige-btn-start-box">
            <button class="com-calendar-marriage-btn-start" @click="clickCalendarStart"><span>即时起盘</span></button>
        </div>
        <div class="com-calendar-marriage-btn-box">
            <button class="com-calendar-marriage-btn button-marriage" @click="clickMarrige"></button>
        </div>
    </div>
</template>

<script>
import { random } from 'lodash';

export default {
    name: 'CalendarInfoBar',
    computed: {
        todayInfo() {
            return this.$store.state.calendar.todayInfo;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    created: function() {
        if(!this.todayInfo.solar){
            this.$store.dispatch('calendar/initTodayInfo');
        }
    },
    methods: {
        clickCalendar() {
            this.$router.replace({ path: '/calendar' });
        },
        clickCalendarStart() {
            this.$store.state.calendar.detailFromPage = 'collate';
            this.$store.dispatch('calendar/startCalendarCollate', {
                cb: ()=> {
                    this.$router.replace('/detail/collate/00000');
                }
            });
        },
        clickMarrige() {
            this.$router.replace({ path: '/marriage' });
        }
    }
}
</script>